import raw from "@/data/repairPrices.json";

export const WA_NUMBER = "4917620366268";

export const waLink = (text) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const BRANDS = Object.keys(raw);

export const modelsOf = (brand) => (brand ? Object.keys(raw[brand]) : []);

export const repairsOf = (brand, model) =>
    brand && model ? raw[brand][model].map(([name, tiers, duration, warranty]) => ({ name, tiers, duration, warranty })) : [];

export const ALL_ROWS = BRANDS.flatMap((brand) =>
    Object.entries(raw[brand]).flatMap(([model, rows]) =>
        rows.map(([name, tiers, duration, warranty]) => ({ brand, model, name, tiers, duration, warranty }))
    )
);

export const TIER_INFO = {
    "Soft OLED": { label: "Hochwertiges Display", sub: "Nahe am Original · vor Einbau geprüft" },
    Premium: { label: "Premium-Akku", sub: "Neue Zellen · volle Kapazität" },
    hochwertig: { label: "Hochwertiges Ersatzteil", sub: "Gleiche Funktion & Passform" },
    "geprüft": { label: "Original, geprüft", sub: "Aus Spendergerät · Herstellerqualität" },
    Original: { label: "Hersteller-Originalteil", sub: "Direkt vom Hersteller" },
    "ohne Ersatzteil": { label: "Arbeitspreis", sub: "Kein Ersatzteil nötig" },
};

export const tierInfo = (key) => TIER_INFO[key] || { label: key || "Festpreis", sub: "inkl. Einbau" };

export const REPAIR_TYPES = [
    { name: "Display", text: "Glas gesprungen, Streifen im Bild oder Touch reagiert nicht mehr? Wir tauschen die komplette Display-Einheit." },
    { name: "Akku", text: "Das Handy hält keinen Tag mehr durch oder geht plötzlich aus? Mit neuem Akku läuft es wieder wie am ersten Tag." },
    { name: "Ladebuchse", text: "Kabel wackelt, lädt nur in einem Winkel oder gar nicht? Wir ersetzen die Ladebuchse." },
    { name: "Kamera", text: "Unscharfe Fotos, schwarzes Bild oder zerkratztes Objektivglas – Front- und Hauptkamera." },
    { name: "Lautsprecher", text: "Kein Ton, Knistern oder Rauschen? Wir tauschen Hörmuschel oder Lautsprecher." },
    { name: "Rückseite", text: "Rückglas gesprungen oder zerkratzt? Neue Rückseite – auch kabelloses Laden funktioniert wieder sicher." },
    { name: "Diagnose", text: "Sie wissen nicht, woran es liegt? Wir prüfen das Gerät und nennen Ihnen den genauen Reparaturpreis." },
    { name: "HDMI-Anschluss", text: "Konsole läuft, aber kein Bild? Wir löten die HDMI-Buchse aus und ersetzen sie." },
    { name: "Lüfter-Service", text: "Konsole wird laut und heiß? Reinigung, neue Wärmeleitpaste und Pads." },
].map((t) => {
    const rows = ALL_ROWS.filter((r) => r.name === t.name && r.tiers.length);
    return { ...t, min: Math.min(...rows.map((r) => r.tiers[0][1])), count: new Set(rows.map((r) => r.model)).size };
}).filter((t) => t.count > 0);

export const POPULAR = [
    { brand: "Apple", model: "iPhone 15", repair: "Display", label: "iPhone 15 Display" },
    { brand: "Apple", model: "iPhone 14", repair: "Akku", label: "iPhone 14 Akku" },
    { brand: "Apple", model: "iPhone 13", repair: "Display", label: "iPhone 13 Display" },
    { brand: "Samsung", model: modelsOf("Samsung").find((m) => /S24$/.test(m)), repair: "Display", label: "Samsung S24 Display" },
].filter((p) => p.model && repairsOf(p.brand, p.model).some((r) => r.name === p.repair));

export const formatPrice = (tiers) => (tiers.length ? `${tiers.length > 1 ? "ab " : ""}${tiers[0][1]} €` : "auf Anfrage");
